import type { AudioPlaybackService } from "../ports";

const audioAdapterRegistry = new Map<string, AudioPlaybackService>();

export const AdapterRegistry = {
	register: (id: string, adapter: AudioPlaybackService) => {
		audioAdapterRegistry.set(id, adapter);
	},
	get: (id: string) => audioAdapterRegistry.get(id),
	/** Remove adapter from registry without cleanup (keeps audio playing) */
	remove: (id: string) => {
		audioAdapterRegistry.delete(id);
	},
	unregister: (id: string) => {
		const adapter = audioAdapterRegistry.get(id);
		adapter?.cleanup?.();
		audioAdapterRegistry.delete(id);
	},
	clear: () => {
		for (const [_id, adapter] of audioAdapterRegistry) {
			adapter.cleanup?.();
		}
		audioAdapterRegistry.clear();
	},
};
